import React, {useState, useEffect, useContext} from 'react';
import clsx from 'clsx';
import {isOutOfStock, nolCoreCartUrl} from "../../../logic/products";
import {getClassList} from "../../../../Utility/siteConfig";
import {CartConfigContext} from "../../../../contexts/CartConfigContext";

export default function AddToNolCoreCartButton({
  product, className = null, ...props
}) {


  if (!product) return null;

  const outOfStock = isOutOfStock(product);
  const disabled = false;
  const url = nolCoreCartUrl(product);
  // const handleClick = evt => {
  //   alert("You are now being redirected to NAPA Online, the sole authorized retailer of Carlyle Tools.\nAfter adding to your cart, press the back button to return to this page.")
  // }

  className = getClassList({
    key: (outOfStock || disabled) ? 'AddToCartButton.disabled' : 'AddToCartButton',
    base: 'text-lg px-4 py-3 uppercase font-bold',
    fallback: [(outOfStock || disabled) ? 'btn-disabled' : 'btn-primary'],
    append: className
  });

  if (!disabled) {
    className = clsx('inline-block text-lg px-2 py-2 uppercase font-bold bg-white border-gray-700 border',
      'transition-all duration-300 hover:scale-105 hover:border-gray-900 opacity-90 hover:opacity-100')
  }

  // TWO copies of the button!
  // the first has target=_blank and is for desktop,
  // the second lacks target, and is for mobile.
  return (
    <div>
      <div className="font-carbon py-2">PURCHASE HERE - EXCLUSIVE RETAIL HOME:</div>

      <div className="text-left hidden lg:block">
        <a className={className} href={url} target="_blank">
          <img className="w-40" style={{maxWidth: '160px'}}
            src="/img/napa/napa-horizontal-black-300.webp" alt="NAPA Auto Parts"/>
        </a>
      </div>
      <div className="text-left block lg:hidden">
        <a className={className} href={url}>
          <img className="w-40" style={{maxWidth: '160px'}}
            src="/img/napa/napa-horizontal-black-300.webp" alt="NAPA Auto Parts"/>
        </a>
      </div>
    </div>
  );
}
